import React from "react";
import { ActivityFormAdminPreviewContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { userService } from "apiServices";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Displays, Forms, Icons, Navigations } from "components";

class ActivityFormAdminPreviewContainer extends React.Component {
  state = {
    isLoading: true,
    activePage: 0,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    let resArr = await Promise.all([
      userService.GET_ACTIVITY_FORM_PDPA_DETAIL(router.params?.id),
    ]);
    if (resArr && resArr[0].status === 200) {
      if (resArr[1] && resArr[1].data) {
        const sortData = {
          ...resArr[0].data,
          question_list: resArr[0].data.question_list.sort(
            (a, b) => a.page - b.page,
          ),
        };
        this.setState({
          initialValue: {
            ...resArr[1].data,
            question_list: resArr[1].data.question_list.map((e, i) => ({
              ...e,
              questions: e.questions.map((f, j) => {
                let render = f;
                if (f.type === "4") {
                  render.pdpa_details =
                    sortData.question_list[i].questions[j].pdpa_details;
                }
                return render;
              }),
            })),
          },
          data: sortData,
          isLoading: false,
        });
      } else {
        this.setState({
          data: {
            ...resArr[0].data,
            question_list: resArr[0].data.question_list.sort(
              (a, b) => a.page - b.page,
            ),
          },
          isLoading: false,
        });
      }
    }
  };

  handleBack = () => {
    const { activePage, tempValues } = this.state;
    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      let temp = false;
      let find =
        tempValues &&
        tempValues[activePage - 1].questions.find(
          (e) => e.jumpToBack || e.jumpToBack === 0,
        );
      if (find) {
        temp = find.jumpToBack;
      }
      this.setState({
        activePage: !temp && temp !== 0 ? activePage - 1 : temp,
        isLoading: false,
      });
    }, 500);
  };

  handleExitPreview = () => {
    const { router } = this.props;
    router.navigate(-1);
  };

  handleSubmit = async (values) => {
    const { activePage, data, tempValues } = this.state;
    const _updateTemp = (masterTempValue, currentValues, jumpToPart) => {
      let temp = masterTempValue;
      const clearData = currentValues.questions.map((e) => {
        let tempValues = e;
        tempValues.is_skip = false;
        delete tempValues.jumpToBack;
        return tempValues;
      });
      if (!temp) {
        temp = [
          {
            title: data.question_list[activePage].title,
            desc: data.question_list[activePage].desc,
            page: data.question_list[activePage].page,
            questions: clearData,
          },
        ];
      } else {
        if (temp[activePage]) {
          temp[activePage] = {
            title: data.question_list[activePage].title,
            desc: data.question_list[activePage].desc,
            page: data.question_list[activePage].page,
            questions: clearData,
          };
        } else {
          temp.push({
            title: data.question_list[activePage].title,
            desc: data.question_list[activePage].desc,
            page: data.question_list[activePage].page,
            questions: clearData,
          });
        }
      }
      if (jumpToPart) {
        for (let index = activePage + 1; index < jumpToPart - 1; index++) {
          if (!temp[index]) {
            temp.push({
              title: data.question_list[index].title,
              desc: data.question_list[index].desc,
              page: data.question_list[index].page,
              questions: data.question_list[index].questions.map((e) => ({
                ...e,
                is_skip: true,
                jumpToBack: activePage,
              })),
            });
          } else {
            temp[index].questions = data.question_list[index].questions.map(
              (e) => ({
                ...e,
                is_skip: true,
                jumpToBack: activePage,
              }),
            );
          }
        }
      }
      return temp;
    };
    // PROCESS
    // =====================================
    // =====================================
    this.setState({
      isLoading: true,
    });
    let findJumpToPart = false;
    if (data.question_list[activePage].jump_to_part) {
      findJumpToPart = data.question_list[activePage].jump_to_part;
    } else {
      let findJumpLv1 = values.questions.find(
        (e) => e.type === "1" && e.answer,
      );
      if (findJumpLv1) {
        let findAns = findJumpLv1.answer_list.find(
          (f) => f.ans === findJumpLv1.answer,
        );
        if (findAns.jump_to_part) {
          findJumpToPart = findAns.jump_to_part;
        }
      }
    }
    setTimeout(() => {
      this.setState({
        tempValues: [..._updateTemp(tempValues, values, findJumpToPart)],
        activePage: !findJumpToPart ? activePage + 1 : findJumpToPart - 1,
        isLoading: false,
      });
    }, 400);
  };

  render() {
    const { router, t } = this.props;
    const { isLoading, activePage, data, initialValue, tempValues } =
      this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Activities", { ns: "common" }),
        path: ROUTE_PATH.ACTIVITIES,
      },
    ];

    const renderQuestion = !data
      ? false
      : tempValues && tempValues[activePage]
        ? tempValues[activePage]
        : initialValue && initialValue.question_list.length > 0
          ? initialValue.question_list[activePage]
          : data.question_list[activePage];
    const isCustomer = router.location.pathname.includes("system");
    return (
      <ActivityFormAdminPreviewContainerStyled isCustomer={isCustomer}>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="activity_form_admin_preview_container">
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              {isCustomer && (
                <div className="preview_notice_layout">
                  <div className="close_preview_row">
                    <div
                      className="close_preview_btn"
                      onClick={this.handleExitPreview}
                    >
                      <span>{t("Close Preview", { ns: "common" })}</span>
                      <Icons.Close color="#4B1E78" width={13} height={13} />
                    </div>
                  </div>
                  <div className="preview_notice_box">
                    <div>
                      {t("Review the registration requirements.", {
                        ns: "common",
                      })}
                    </div>
                    <div>
                      {t('Click "Next" to view all sections.', {
                        ns: "common",
                      })}
                    </div>
                  </div>
                </div>
              )}
              <div className="header_question_layout">
                <div className="title">{renderQuestion.title}</div>
                <div className="desc">{renderQuestion.desc}</div>
              </div>
              <div className="quiz_container_layout">
                <Forms.QuickTestActivityForm
                  isDisabledForm
                  currentPage={activePage + 1}
                  totalPage={data.question_list.length}
                  initialValue={{ questions: renderQuestion.questions }}
                  onBack={this.handleBack}
                  onSubmit={this.handleSubmit}
                />
              </div>
            </>
          )}
        </div>
      </ActivityFormAdminPreviewContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common"])(withRouter(ActivityFormAdminPreviewContainer)));
